<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-hxBiz-preOrderPurchase',
  components: { PageTable },
}
</script>
